<template>

	<transition-group 
		name="alert" 
		tag="div"
		enter-active-class="animate__animated animate__fadeIn animate__faster"
		leave-to-class="animate__animated animate__fadeOut animate__faster"
	> 
		<div key="1" class="featherlight" v-if="shouldShow==true" style="display: block;" v-on:click.self="toggleParticipantForm()">
			<div class="featherlight-content" id="participant_form" >
				<button class="featherlight-close-icon featherlight-close" aria-label="Close" v-on:click.self="toggleParticipantForm()">✕</button>
				<section class="popup_content featherlight-inner section" style="max-width: 45rem;">
					<div class="constraint">
						<h2 v-if="participant_id > 0">Edit a Participant</h2>
						<h2 v-else>Add a Participant</h2>
						<div class="form_style">
							<template v-if="errors != [] && errors != null && Object.keys(errors).length > 0">
								<template v-if="typeof errors == 'string'">
								<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>{{ errors }}</span></p>
								</template>
								<template v-else>
									<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>There was a problem with the form submission. Please check the errors below and try again.</span></p>
								</template>
							</template>
							<p>
								<label for="first_name" class="required">First Name</label>
								<input type="text" id="first_name" name="first_name" placeholder="Enter a first name" v-model="first_name" :class="{ error: errors.first_name }">
								<span v-if="errors.first_name" class="validation-error">{{ errors.first_name[0] }}</span>
							</p>

							<p>
								<label for="last_name" class="required">Last Name</label>
								<input type="text" id="last_name" name="last_name" placeholder="Enter a last name" v-model="last_name" :class="{ error: errors.last_name }">
								<span v-if="errors.last_name" class="validation-error">{{ errors.last_name[0] }}</span>
							</p>

							<p>
								<label for="contact_number">Contact Number</label>
								<input type="text" id="contact_number" name="contact_number" placeholder="Enter a contact number" v-model="contact_number" :class="{ error: errors.contact_number }">
								<span v-if="errors.contact_number" class="validation-error">{{ errors.contact_number[0] }}</span>
							</p>
							<p>
								<label for="email_address" data-help="If the participant does not have an email address they will not be able to make a payment online">Email Address</label>
								<input type="text" id="email_address" name="email_address" placeholder="Enter email address" v-model="email_address" :class="{ error: errors.email_address }">
								<span v-if="errors.email_address" class="validation-error">{{ errors.email_address[0] }}</span>
							</p>

							<p class="half" style="margin-left: auto;">
								<button type="submit" class="button solid arrow wide medium" v-on:click="submitForm()" :style="'--accent:' + this.accent">Save</button>
							</p>
						</div>
					</div>
				</section>

			</div>
		</div>
	 </transition-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	
	props: [
		'accent',
		'uuid'
	],

	data: () => {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			participant_id: null,
			first_name: '',
			last_name: '',
			contact_number: '',
			email_address: '',
			errors: [],
			shouldShow: false,
			participant: null
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
	},

	methods: {

		...mapActions(['addAlert']),

		wrap: function(el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		},

		toggleParticipantForm: function(participant = null){
			if(this.shouldShow==true) {
				this.shouldShow = false;
				this.success = false;
				this.errors = [];
				this.participant_id = null;
				this.first_name = '';
				this.last_name = '';
				this.contact_number = '';
				this.email_address = '';
				this.participant = null;
			}else{
				this.shouldShow = true;
				this.participant = participant;
				this.$nextTick(function() {
					if(this.participant != null) {
						this.participant_id = this.participant.id;
						this.first_name = this.participant.first_name;
						this.last_name = this.participant.last_name;
						this.contact_number = this.participant.contact_number;
						this.email_address = this.participant.email_address;
					}else{
						this.participant_id = null;
					}
					this.initStyledSelect();
				});
			}
		},

		submitForm: function() {
			var self = this;
			axios.post('/ajax/postParticipantForm', {
				uuid: this.uuid,
				participant_id: this.participant_id,
				first_name: this.first_name,
				last_name: this.last_name,
				contact_number: this.contact_number,
				email_address: this.email_address
			})
			.then(response => {
				if(response.data=='success') {
					this.$root.$refs.participantlist.getParticipants();
					this.shouldShow = false;
					var self = this;
					setTimeout(function() {
						self.alert('<strong>Great!</strong> The participant list has been updated', 'success')
					}, 500);
					
				}else{
					this.errors = response.data['errors'];
					document.getElementById('participant_form').scrollIntoView({behavior: "smooth"});
				}
			})
			.catch(error => {
				if(error.response.status == 422) {
					var errors = error.response.data['errors'];
					this.errors = errors;
					document.getElementById('participant_form').scrollIntoView({behavior: "smooth"});
				}
			});

		},

		initStyledSelect: function(){
			// do a pure javascript version of the select wrapper code
			for(var i=0; i<document.querySelectorAll(".form_style select, .styled_select").length; i++) {
				var elem = document.querySelectorAll(".form_style select, .styled_select")[i];
				if(!elem.parentElement.classList.contains('select_wrapper')) {
					var wrapper = document.createElement('div');
					wrapper.classList.add("select_wrapper");
					this.wrap(elem, wrapper);
				}
			}
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},

	}
};
</script>